






























































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import api from "@/getinfo-api";
import userList, { UsersListParams } from "@/getinfo-api/users";
import { Company as ICompany } from "@/api/models/company";
import { User as IUser } from "@/api/models/user";
import { UsersList as IUsersList } from "@/api/models/users-list";
import { EmployeesList2 as IEmployeesList2 } from "@/api/models/employees-list2";
import { debounce, uniqBy } from "lodash";
import { AxiosError } from "axios";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { EmployeeCreate as IEmployeeCreate } from "@/api/models/employee-create";
import EmployeeRoles from "@/components/companies/EmployeeRoles.vue";
import { isRoot, getCurrentUserId } from "@/plugins/roles";
import CompanyFileSizeLimit from "@/components/companies/CompanyFileSizeLimit.vue";
import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import { Employee as IEmployee } from "@/api/models/employee";
import { CommissionPerson as ICommissionPerson } from "@/api/models/commission-person";
import { CompanyDocumentInfo as ICompanyDocumentInfo } from "@/api/models/company-document-info";
import CompanyRequisitesView from "@/components/companies/CompanyRequisitesView.vue";
import {
  bookkeepingModule,
  learningDocumentsModule
} from "@/plugins/modules-detect";
import tz from "@/plugins/time-zones";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import TextField from "@/components/form/CustomPage/textField.vue";
import StudentEdit from "@/views/students/StudentEdit.vue";
import CField from "@/components/form/CField.vue";
import CompanyConfiguration from "@/components/companies/CompanyConfiguration.vue";

@Component({
  components: {
    CompanyConfiguration,
    CField,
    StudentEdit,
    TextField,
    CBlock,
    EmployeeRoles,
    CompanyFileSizeLimit,
    CompanyRequisitesView
  }
})
export default class CompanyPage extends Vue {
  @Prop(Object) companyInfo!: ICompany;
  employees: Array<IEmployee> = [];
  users: Array<IUser | undefined> = [];
  searchUsers!: string | undefined;
  processing: boolean = false;
  employeeIdToDelete!: string | undefined;
  limit: number = 30;
  offset: number = 0;
  showSpinner: boolean = false;
  employeesCount: number = 0;
  commission: Array<ICommissionPerson> = [];
  currentUserIsEmployee!: boolean;

  data() {
    return {
      currentUserIsEmployee: undefined,
      params: undefined,
      emailArray: undefined,
      searchUsers: undefined,
      employeeIdToDelete: undefined
    };
  }

  get companyTimeZone() {
    let companyTZ;

    if (this.companyInfo?.timeZone) {
      companyTZ = tz.filter(
        el => el.timezone === this.companyInfo?.timeZone
      )?.[0];
    }

    return companyTZ;
  }

  get learningDocuments() {
    return learningDocumentsModule();
  }

  get bookkeeping() {
    return bookkeepingModule();
  }

  get employeeInStore() {
    return this.$store.getters.userIsEmployee;
  }

  get currentEmployee() {
    let employee: IEmployee;
    const responsibleInStorage = localStorage.getItem("employee");
    if (this.employeeInStore && this.employeeInStore.id) {
      employee = this.employeeInStore;
    } else {
      employee = responsibleInStorage
        ? JSON.parse(responsibleInStorage)
        : undefined;
    }
    return employee;
  }

  get companyAccess() {
    return this.root
      ? true
      : this.$store.getters.selectedCompany.id === this.companyInfo.id;
  }

  get currentUser() {
    return getCurrentUserId();
  }

  isCompanyEmployee() {
    if (this.companyInfo?.id) {
      let params: EmployeeListParams = {
        userIds: [this.currentUser],
        id: this.companyInfo.id
      };
      employee(params)
        .then(() => {
          this.currentUserIsEmployee = true;
          this.employeesUser();
          this.getCommission();
        })
        .catch(() => {
          this.currentUserIsEmployee = false;
          if (this.root) {
            this.currentUserIsEmployee = true;
            this.employeesUser();
            this.getCommission();
          }
        });
    }
  }

  getCommission() {
    if (this.companyInfo?.id) {
      api.CompanyApi.getDocumentInfo(this.companyInfo.id).then(
        (res: { data: ICompanyDocumentInfo }) => {
          res.data.commissionPersons
            ? (this.commission = res.data.commissionPersons)
            : null;
        }
      );
    }
  }

  showMore() {
    this.offset += this.limit;
    this.employeesUser(this.offset);
  }

  getEmployeeAfterSave() {
    this.employees = [];
    this.offset = 0;
    this.employeesUser();
  }

  get contentManager() {
    return this.$store.getters.roles.includes("content_manager");
  }

  get learningRequestManager() {
    return this.currentEmployee?.roles.includes("learning_request_manager");
  }

  get documentManager() {
    return this.currentEmployee?.roles.includes("document_manager");
  }

  get root() {
    return isRoot();
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  employeesUser(offset: number = 0) {
    this.showSpinner = true;
    let params: EmployeeListParams = {
      id: this.companyInfo.id ? this.companyInfo.id : "",
      limit: this.limit,
      offset: offset
    };

    employee(params)
      .then((res: { data: IEmployeesList2 }) => {
        this.employeesCount = res.data.count;
        res.data.employees?.forEach(element => {
          this.employees.push(element);
        });
      })
      .finally(() => {
        this.showSpinner = false;
      });
  }

  hideModal() {
    this.$bvModal.hide("modal-1");
    this.employeeIdToDelete = undefined;
  }

  showModalToDeleteEmployee(employeeId: string) {
    this.$bvModal.show("modal-1");
    this.employeeIdToDelete = employeeId;
  }

  @Watch("searchUsers")
  _showSpinner() {
    this.processing = true;
  }

  @Watch("searchUsers")
  searchUserByParams = debounce(function() {
    //@ts-ignore
    let _this = this;
    _this.users = [];
    let allParams = [];
    let firstNameParam: UsersListParams = {
      firstName: _this.searchUsers
    };
    let lastNameParam: UsersListParams = {
      lastName: _this.searchUsers
    };
    let emailParam: UsersListParams = {
      email: _this.searchUsers
    };
    allParams.push(firstNameParam, lastNameParam, emailParam);
    allParams.forEach(element => {
      userList(element).then((res: { data: IUsersList }) => {
        if (res.data.users && res.data.users.length > 0) {
          res.data.users.forEach(item => {
            _this.users.push(item);
          });
          _this.users = uniqBy(_this.users, "id");
        }
        _this.processing = false;
      });
    });
  }, 300);

  removeFromCompany() {
    if (this.employeeIdToDelete && this.companyInfo?.id) {
      api.EmployeeApi._delete(this.companyInfo.id, this.employeeIdToDelete)
        .then(() => {
          this.employees = [];
          this.employeesUser();
          this.employeeIdToDelete = undefined;
          this.$bvModal.hide("modal-1");
        })
        .catch((error: AxiosError<IValidationErrorResponse>) => {
          if (error.response) {
            this.$bvToast.toast(`${error.response.data.message}`, {
              variant: "danger",
              title: `${this.$tc(this.$translate.Error)}`
            });
          } else {
            this.$bvToast.toast(
              `${this.$tc(this.$translate.SorrySomethingWentWrong)}`,
              {
                variant: "danger",
                title: `${this.$tc(this.$translate.Error)}`
              }
            );
          }
        });
    }
  }

  get screenWidth() {
    return window.innerWidth;
  }

  goToInvitePage() {
    this.$router.push({ name: "inviteUsers" });
  }
  goToImportPage() {
    this.$router.push({ name: "importUsers" });
  }

  addToCompany(userId: string | undefined) {
    if (userId && this.companyInfo?.id) {
      let paramsEmployee: IEmployeeCreate = {
        userId: userId,
        roles: ["content_manager"]
      };
      api.EmployeeApi.create(this.companyInfo.id, paramsEmployee)
        .then(() => {
          this.$bvToast.toast(`${this.$tc(this.$translate.Successful)}`, {
            variant: "success",
            title: `${this.$tc(this.$translate.Successful)}`
          });
          this.employees = [];
          this.searchUsers = "";
          this.users = [];
          this.employeesUser();
        })
        .catch((error: AxiosError<IValidationErrorResponse>) => {
          if (error.response) {
            this.$bvToast.toast(`${error.response.data.message}`, {
              variant: "danger",
              title: "Error"
            });
          }
        });
    }
  }
  created() {
    this.isCompanyEmployee();
  }
}
